import {NEWS_STATUS, NEWS_APPROVAL_STATUS, HIGHLIGHT} from '@/common/Constant'
import {mapActions, mapState} from 'vuex'

export const filterSidebarList = {
  data() {
    return {
      userList: [],
      newsStatus: NEWS_STATUS,
      newsApprovalStatus: NEWS_APPROVAL_STATUS,
      highlight: HIGHLIGHT,
      provinceList: [],
      districtList: [],
      communeList: [],
      zoneTypeList: [],
      nameList: [],
      filter: {
        userSelected: [],
        statusSelected: [],
        approvalStatusSelected: [],
        highlightSelected: [],
        provinceSelected: [],
        districtSelected: [],
        communeSelected: [],
        zoneTypeSelected: [],
        nameSelected: []
      },
      filterMap: {},
      countOpenFilterPanel: 0
    }
  },
  computed: {
    ...mapState('auth', ['users']),
    userSelected() {
      return this.filter.userSelected
    },
    statusSelected() {
      return this.filter.statusSelected
    },
    approvalStatusSelected() {
      return this.filter.approvalStatusSelected
    },
    highlightSelected() {
      return this.filter.highlightSelected
    },
    provinceSelected() {
      return this.filter.provinceSelected
    },
    districtSelected() {
      return this.filter.districtSelected
    },
    communeSelected() {
      return this.filter.communeSelected
    },
    zoneTypeSelected() {
      return this.filter.zoneTypeSelected
    },
    nameSelected() {
      return this.filter.nameSelected
    }
  },
  methods: {
    ...mapActions('auth', ['getUserList']),
    ...mapActions('common', ['getLocationAndZoneTypeList']),
    initData() {
      if (Object.prototype.hasOwnProperty.call(localStorage, 'provinceList'))
        this.provinceList = JSON.parse(localStorage.getItem('provinceList'))
      if (Object.prototype.hasOwnProperty.call(localStorage, 'districtList'))
        this.districtList = JSON.parse(localStorage.getItem('districtList'))
      if (Object.prototype.hasOwnProperty.call(localStorage, 'communeList'))
        this.communeList = JSON.parse(localStorage.getItem('communeList'))
      if (Object.prototype.hasOwnProperty.call(localStorage, 'zoneTypeList'))
        this.zoneTypeList = JSON.parse(localStorage.getItem('zoneTypeList'))
    },
    mapFilter(_filterItem, _key) {
      this.filterMap[_key] = []
      _filterItem.forEach(item => {
        this.filterMap[_key].push(item['id'])
      })
      if (!this.filterMap[_key].length) {
        delete this.filterMap[_key]
      }
    },
    customLabelUserList({name, full_name}) {
      return `${name} [${full_name}]`
    },
    async getUserListWhenOpenSidebar() {
      if (this.countOpenFilterPanel === 0) {
        await Promise.all([
          this.getUserList(),
          this.getLocationAndZoneTypeList()
        ])
      } else {
        if (!this.userList.length) {
          await this.getUserList()
        }
      }
      this.userList = this.users
      this.initData()
      this.countOpenFilterPanel++
    },
    resetCondition() {
      Object.keys(this.filter).forEach(key => {
        this.filter[key] = []
      })
      this.nameList = []
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        id: newTag
      }
      this.nameList.push(tag)
      this.filter.nameSelected.push(tag)
    },
  },
  watch: {
    userSelected(value) {
      this.mapFilter(value, 'user_ids')
    },
    statusSelected(value) {
      this.mapFilter(value, 'status')
    },
    approvalStatusSelected(value) {
      this.mapFilter(value, 'approval_status')
    },
    highlightSelected(value) {
      this.mapFilter(value, 'highlight')
    },
    provinceSelected(value) {
      this.mapFilter(value, 'province_ids')
    },
    districtSelected(value) {
      this.mapFilter(value, 'district_ids')
    },
    communeSelected(value) {
      this.mapFilter(value, 'commune_ids')
    },
    zoneTypeSelected(value) {
      this.mapFilter(value, 'zonetype_ids')
    },
    nameSelected(value) {
      this.mapFilter(value, 'names')
    }
  }
}
